import React from 'react';
import { Helmet } from 'react-helmet-async';

const PageTitleDes = ({ title, description, keywords = [], image, url }) => {
    const currentUrl = url || `${window.location.origin}${window.location.pathname}`;
    return (
        <Helmet>
            <title>{title}</title>

            <meta name="description" content={description} />

            {keywords?.length > 0 && (
                <meta name="keywords" content={keywords.join(', ')} />
            )}

            <link rel="canonical" href={currentUrl} />

            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            {image && <meta property="og:image" content={image} />}
            <meta property="og:url" content={currentUrl} />
            <meta property="og:type" content="article" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {image && <meta name="twitter:image" content={image} />}
        </Helmet>
    );
};

export default PageTitleDes;